import { Button } from "react-bootstrap";
import { Modal } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";

const ModalDesasignar = ({ modals, handlerModal, setRefetch }) => {

    //? ESTADOS GLOABLES
    const { loads } = useGeneralAppStore();
    const { acta } = useActaDetalleStore();

    //TODO API
    const { quitarNotificadorAsignado } = useActas();

    // quitarNotificadorAsignado({
    //     acta_id: id,
    //     user_id_asignado: user_id_asignado,
    // });

    return (
        <>
            <Modal
                show={modals.includes('desasignar_notificador')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "desasignar_notificador" })}
                title={() => "Desasignar notificador"}
            >

                <Button
                    size="lg"
                    className="w-100"
                    onClick={() => quitarNotificadorAsignado({
                        acta_id: acta.id,
                        user_id_asignado: acta.user_id_asignado,
                    }, setRefetch)}
                >
                    {loads.includes('desasignar_notificador')
                        ? "Guardando cambios..."
                        : "Desasignar"}
                </Button>

            </Modal>
        </>
    );
}
export default ModalDesasignar;